webpackJsonp([6],{

/***/ "//z2":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("js6r")(
  /* script */
  __webpack_require__("ji5e"),
  /* template */
  __webpack_require__("VVL9"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "1bhS":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M7.69 7.7l-.905.905a.7.7 0 0 0 .99.99l1.85-1.85c.411-.412.411-1.078 0-1.49l-1.85-1.85a.7.7 0 0 0-.99.99l.905.905H4.48a.7.7 0 0 0 0 1.4h3.21z\"/></g></svg>\n"

/***/ }),

/***/ "28cu":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("js6r")(
  /* script */
  __webpack_require__("UPUc"),
  /* template */
  __webpack_require__("GJO7"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3AYy":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><circle id=\"Oval\" cx=\"11\" cy=\"11\" r=\"5.10714286\"></circle></svg>\n"

/***/ }),

/***/ "3U/b":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("js6r")(
  /* script */
  __webpack_require__("6nVp"),
  /* template */
  __webpack_require__("vxKc"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "6c7U":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M7 5.969L5.599 4.568a.29.29 0 0 0-.413.004l-.614.614a.294.294 0 0 0-.004.413L5.968 7l-1.4 1.401a.29.29 0 0 0 .004.413l.614.614c.113.114.3.117.413.004L7 8.032l1.401 1.4a.29.29 0 0 0 .413-.004l.614-.614a.294.294 0 0 0 .004-.413L8.032 7l1.4-1.401a.29.29 0 0 0-.004-.413l-.614-.614a.294.294 0 0 0-.413-.004L7 5.968z\"/></g></svg>\n"

/***/ }),

/***/ "6nVp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__job_component_vue__ = __webpack_require__("bI9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__job_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__job_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_job_component_vue__ = __webpack_require__("jyEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_job_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dropdown_job_component_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      required: true
    },

    jobs: {
      type: Array,
      required: true
    },

    isFirstColumn: {
      type: Boolean,
      required: false,
      default: false
    },

    stageConnectorClass: {
      type: String,
      required: false,
      default: ''
    }
  },

  components: {
    jobComponent: __WEBPACK_IMPORTED_MODULE_0__job_component_vue___default.a,
    dropdownJobComponent: __WEBPACK_IMPORTED_MODULE_1__dropdown_job_component_vue___default.a
  },

  methods: {
    firstJob: function firstJob(list) {
      return list[0];
    },
    jobId: function jobId(job) {
      return 'ci-badge-' + job.name;
    },
    buildConnnectorClass: function buildConnnectorClass(index) {
      return index === 0 && !this.isFirstColumn ? 'left-connector' : '';
    }
  }
});

/***/ }),

/***/ "8KGO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__job_name_component_vue__ = __webpack_require__("ws8e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__job_name_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__job_name_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__job_component_vue__ = __webpack_require__("bI9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__job_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__job_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_mixins_tooltip__ = __webpack_require__("qHTm");





/**
 * Renders the dropdown for the pipeline graph.
 *
 * The following object should be provided as `job`:
 *
 * {
 *   "id": 4256,
 *   "name": "test",
 *   "status": {
 *     "icon": "icon_status_success",
 *     "text": "passed",
 *     "label": "passed",
 *     "group": "success",
 *     "details_path": "/root/ci-mock/builds/4256",
 *     "action": {
 *       "icon": "icon_action_retry",
 *       "title": "Retry",
 *       "path": "/root/ci-mock/builds/4256/retry",
 *       "method": "post"
 *     }
 *   }
 * }
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    job: {
      type: Object,
      required: true
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__vue_shared_mixins_tooltip__["a" /* default */]],

  components: {
    jobComponent: __WEBPACK_IMPORTED_MODULE_1__job_component_vue___default.a,
    jobNameComponent: __WEBPACK_IMPORTED_MODULE_0__job_name_component_vue___default.a
  },

  computed: {
    tooltipText: function tooltipText() {
      return this.job.name + ' - ' + this.job.status.label;
    }
  }
});

/***/ }),

/***/ "8r0p":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.17142857,5.97142857 L15.8714286,13.6714286 C16.1857143,13.9857143 16.1857143,14.4571429 15.8714286,14.7714286 L14.7714286,15.8714286 C14.4571429,16.1857143 13.9857143,16.1857143 13.6714286,15.8714286 L5.97142857,8.17142857 C5.65714286,7.85714286 5.65714286,7.38571429 5.97142857,7.07142857 L7.07142857,5.97142857 C7.38571429,5.65714286 7.85714286,5.65714286 8.17142857,5.97142857\" id=\"Shape\"></path></svg>\n"

/***/ }),

/***/ "BX53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_graph_graph_component_vue__ = __webpack_require__("28cu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_graph_graph_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_graph_graph_component_vue__);



document.addEventListener('DOMContentLoaded', function () {
  return new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#js-pipeline-graph-vue',
    components: {
      pipelineGraph: __WEBPACK_IMPORTED_MODULE_1__components_graph_graph_component_vue___default.a
    },
    render: function render(createElement) {
      return createElement('pipeline-graph');
    }
  });
});

/***/ }),

/***/ "DWvw":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    ref: "tooltip",
    staticClass: "dropdown-menu-toggle build-content",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "data-container": "body",
      "title": _vm.tooltipText
    }
  }, [_c('job-name-component', {
    attrs: {
      "name": _vm.job.name,
      "status": _vm.job.status
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dropdown-counter-badge"
  }, [_vm._v("\n      " + _vm._s(_vm.job.size) + "\n    ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu big-pipeline-graph-dropdown-menu js-grouped-pipeline-dropdown"
  }, [_c('li', {
    staticClass: "scrollable-menu"
  }, [_c('ul', _vm._l((_vm.job.jobs), function(item) {
    return _c('li', [_c('job-component', {
      attrs: {
        "job": item,
        "is-dropdown": true,
        "css-class-job-name": "mini-pipeline-graph-dropdown-item"
      }
    })], 1)
  }))])])])
},staticRenderFns: []}

/***/ }),

/***/ "Dx73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("P6M/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__http_status__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Polling utility for handling realtime updates.
 * Service for vue resouce and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = gl.utils.normalizeHeaders(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);

      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status___default.a.OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart() {
      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "GJO7":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "build-content middle-block js-pipeline-graph"
  }, [_c('div', {
    staticClass: "pipeline-visualization pipeline-graph"
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "loading-icon fa fa-spin fa-spinner fa-3x",
    attrs: {
      "aria-label": "Loading",
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('ul', {
    staticClass: "stage-column-list"
  }, _vm._l((_vm.state.graph), function(stage, index) {
    return _c('stage-column-component', {
      key: stage.name,
      attrs: {
        "title": _vm.capitalizeStageName(stage.name),
        "jobs": stage.groups,
        "stage-connector-class": _vm.stageConnectorClass(index, stage),
        "is-first-column": _vm.isFirstColumn(index)
      }
    })
  })) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ "IaBA":
/***/ (function(module, exports) {

module.exports = "<svg width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.25,14.9765625 C19.25,14.1380166 19.0234398,13.3697952 18.5703125,12.671875 L12.6796875,18.5546875 C13.3932327,19.0182315 14.1666625,19.25 15,19.25 C15.5781279,19.25 16.1289036,19.1367199 16.6523438,18.9101562 C17.1757839,18.6835926 17.6276023,18.3802102 18.0078125,18 C18.3880227,17.6197898 18.690103,17.1653672 18.9140625,16.6367188 C19.138022,16.1080703 19.25,15.5546904 19.25,14.9765625 Z M11.4453125,17.3125 L17.34375,11.421875 C16.6406215,10.9479143 15.8593793,10.7109375 15,10.7109375 C14.2291628,10.7109375 13.5182324,10.9010398 12.8671875,11.28125 C12.2161426,11.6614602 11.7005227,12.1796842 11.3203125,12.8359375 C10.9401023,13.4921908 10.75,14.2057253 10.75,14.9765625 C10.75,15.8203167 10.9817685,16.5989548 11.4453125,17.3125 Z M21,14.9765625 C21,15.7942749 20.8411474,16.5755171 20.5234375,17.3203125 C20.2057276,18.0651079 19.7799506,18.7057265 19.2460938,19.2421875 C18.7122369,19.7786485 18.0742225,20.2057276 17.3320312,20.5234375 C16.58984,20.8411474 15.8125041,21 15,21 C14.1874959,21 13.41016,20.8411474 12.6679688,20.5234375 C11.9257775,20.2057276 11.2877631,19.7786485 10.7539062,19.2421875 C10.2200494,18.7057265 9.79427242,18.0651079 9.4765625,17.3203125 C9.15885258,16.5755171 9,15.7942749 9,14.9765625 C9,14.1588501 9.15885258,13.37891 9.4765625,12.6367188 C9.79427242,11.8945275 10.2200494,11.255211 10.7539062,10.71875 C11.2877631,10.182289 11.9257775,9.75520992 12.6679688,9.4375 C13.41016,9.11979008 14.1874959,8.9609375 15,8.9609375 C15.8125041,8.9609375 16.58984,9.11979008 17.3320312,9.4375 C18.0742225,9.75520992 18.7122369,10.182289 19.2460938,10.71875 C19.7799506,11.255211 20.2057276,11.8945275 20.5234375,12.6367188 C20.8411474,13.37891 21,14.1588501 21,14.9765625 Z\"></path></svg>\n"

/***/ }),

/***/ "IpQs":
/***/ (function(module, exports) {

module.exports = "<svg width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.6114971,16.0821413 C20.6114971,16.106323 20.6090789,16.1232499 20.6042426,16.1329226 C20.2947172,17.42906 19.6466582,18.4797378 18.6600462,19.2849873 C17.6734341,20.0902369 16.5175677,20.4928556 15.1924122,20.4928556 C14.4863075,20.4928556 13.8031856,20.3598584 13.1430261,20.0938601 C12.4828665,19.8278617 11.8940517,19.4482152 11.376564,18.9549092 L10.4407381,19.8907351 C10.3488478,19.9826254 10.2400319,20.0285699 10.1142872,20.0285699 C9.98854256,20.0285699 9.87972669,19.9826254 9.78783635,19.8907351 C9.69594601,19.7988447 9.65000153,19.6900289 9.65000153,19.5642842 L9.65000153,16.3142842 C9.65000153,16.1885395 9.69594601,16.0797236 9.78783635,15.9878333 C9.87972669,15.895943 9.98854256,15.8499985 10.1142872,15.8499985 L13.3642872,15.8499985 C13.4900319,15.8499985 13.5988478,15.895943 13.6907381,15.9878333 C13.7826285,16.0797236 13.828573,16.1885395 13.828573,16.3142842 C13.828573,16.4400289 13.7826285,16.5488447 13.6907381,16.6407351 L12.6968765,17.6345967 C13.0402562,17.9537947 13.4295752,18.200444 13.8648453,18.374552 C14.3001153,18.5486601 14.7523057,18.6357128 15.2214301,18.6357128 C15.8694988,18.6357128 16.4740315,18.4785343 17.0350462,18.1641726 C17.5960609,17.8498109 18.0458332,17.4169655 18.3843765,16.8656235 C18.4375762,16.7834058 18.5657371,16.5004845 18.7688631,16.0168512 C18.8075538,15.9056155 18.8800977,15.8499985 18.9864971,15.8499985 L20.3793542,15.8499985 C20.4422265,15.8499985 20.4966345,15.8729707 20.5425797,15.9189159 C20.5885248,15.9648611 20.6114971,16.019269 20.6114971,16.0821413 Z M20.7928587,10.2785699 L20.7928587,13.5285699 C20.7928587,13.6543146 20.7469142,13.7631305 20.6550238,13.8550208 C20.5631335,13.9469111 20.4543176,13.9928556 20.328573,13.9928556 L17.078573,13.9928556 C16.9528283,13.9928556 16.8440124,13.9469111 16.7521221,13.8550208 C16.6602317,13.7631305 16.6142872,13.6543146 16.6142872,13.5285699 C16.6142872,13.4028252 16.6602317,13.2940094 16.7521221,13.202119 L17.7532381,12.2010029 C17.0374607,11.5384252 16.1935332,11.2071413 15.2214301,11.2071413 C14.5733614,11.2071413 13.9688287,11.3643198 13.407814,11.6786815 C12.8467993,11.9930432 12.397027,12.4258886 12.0584837,12.9772306 C12.005284,13.0594483 11.8771231,13.3423696 11.6739971,13.8260029 C11.6353064,13.9372386 11.5627625,13.9928556 11.4563631,13.9928556 L10.0127247,13.9928556 C9.9498524,13.9928556 9.89544446,13.9698834 9.84949929,13.9239382 C9.80355412,13.877993 9.78058188,13.8235851 9.78058188,13.7607128 L9.78058188,13.7099315 C10.0949436,12.4137941 10.7478388,11.3631163 11.7392872,10.5578668 C12.7307356,9.75261722 13.8914383,9.34999847 15.2214301,9.34999847 C15.9275348,9.34999847 16.6142839,9.48420472 17.281698,9.75262124 C17.949112,10.0210378 18.541554,10.3994752 19.0590417,10.8879449 L20.0021221,9.95211901 C20.0940124,9.86022867 20.2028283,9.81428419 20.328573,9.81428419 C20.4543176,9.81428419 20.5631335,9.86022867 20.6550238,9.95211901 C20.7469142,10.0440094 20.7928587,10.1528252 20.7928587,10.2785699 Z\"></path></svg>\n"

/***/ }),

/***/ "L3NB":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    ref: "tooltip",
    staticClass: "ci-action-icon-wrapper js-ci-status-icon",
    attrs: {
      "data-method": _vm.actionMethod,
      "title": _vm.tooltipText,
      "href": _vm.link,
      "rel": "nofollow",
      "data-toggle": "tooltip",
      "data-container": "body",
      "aria-label": "Job's action"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.actionIconSvg)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "Lwn1":
/***/ (function(module, exports) {

module.exports = "<svg width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.5401786,15.2320328 L11.90625,20.5858274 C11.7950143,20.6486998 11.6994982,20.6559541 11.6196987,20.6075908 C11.5398992,20.5592275 11.5,20.4721748 11.5,20.3464301 L11.5,9.66785867 C11.5,9.54211399 11.5398992,9.45506129 11.6196987,9.40669795 C11.6994982,9.35833462 11.7950143,9.36558901 11.90625,9.42846135 L21.5401786,14.782256 C21.6514142,14.8451283 21.7070312,14.9200904 21.7070312,15.0071444 C21.7070312,15.0941984 21.6514142,15.1691604 21.5401786,15.2320328 Z\"></path></svg>\n"

/***/ }),

/***/ "Mb1M":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M4.7 5.3c0-.2.1-.3.3-.3h.9c.2 0 .3.1.3.3v3.4c0 .2-.1.3-.3.3H5c-.2 0-.3-.1-.3-.3V5.3m3 0c0-.2.1-.3.3-.3h.9c.2 0 .3.1.3.3v3.4c0 .2-.1.3-.3.3H8c-.2 0-.3-.1-.3-.3V5.3\"/></g></svg>\n"

/***/ }),

/***/ "On1c":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.4583333,12.375 L8.70008808,12.375 C8.45889044,12.375 8.25,12.5826293 8.25,12.8387529 L8.25,14.2029137 C8.25,14.4551799 8.4515113,14.6666667 8.70008808,14.6666667 L12.9619841,14.6666667 C13.3891296,14.6666667 13.75,14.3193051 13.75,13.8908129 L13.75,13.2899463 L13.75,6.42552703 C13.75,6.16226705 13.5423707,5.95833333 13.2862471,5.95833333 L11.9220863,5.95833333 C11.6698201,5.95833333 11.4583333,6.16750307 11.4583333,6.42552703 L11.4583333,12.375 Z\" id=\"Combined-Shape\" transform=\"translate(11.000000, 10.312500) rotate(-315.000000) translate(-11.000000, -10.312500) \"></path></svg>\n"

/***/ }),

/***/ "P6M/":
/***/ (function(module, exports) {

/**
 * exports HTTP status codes
 */

var statusCodes = {
  NO_CONTENT: 204,
  OK: 200
};

module.exports = statusCodes;

/***/ }),

/***/ "RVV4":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.1458333,9.85416667 L12.1458333,6.74047388 C12.1458333,6.4826434 11.9382041,6.28571429 11.6820804,6.28571429 L10.3179196,6.28571429 C10.0656535,6.28571429 9.85416667,6.48931709 9.85416667,6.74047388 L9.85416667,9.85416667 L6.74047388,9.85416667 C6.4826434,9.85416667 6.28571429,10.0617959 6.28571429,10.3179196 L6.28571429,11.6820804 C6.28571429,11.9343465 6.48931709,12.1458333 6.74047388,12.1458333 L9.85416667,12.1458333 L9.85416667,15.2595261 C9.85416667,15.5173566 10.0617959,15.7142857 10.3179196,15.7142857 L11.6820804,15.7142857 C11.9343465,15.7142857 12.1458333,15.5106829 12.1458333,15.2595261 L12.1458333,12.1458333 L15.2595261,12.1458333 C15.5173566,12.1458333 15.7142857,11.9382041 15.7142857,11.6820804 L15.7142857,10.3179196 C15.7142857,10.0656535 15.5106829,9.85416667 15.2595261,9.85416667 L12.1458333,9.85416667 Z\" id=\"Combined-Shape\" transform=\"translate(11.000000, 11.000000) rotate(-45.000000) translate(-11.000000, -11.000000) \"></path></svg>\n"

/***/ }),

/***/ "So2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_ci_icon_vue__ = __webpack_require__("KU3T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_ci_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vue_shared_components_ci_icon_vue__);



/**
 * Component that renders both the CI icon status and the job name.
 * Used in
 *  - Badge component
 *  - Dropdown badge components
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      type: String,
      required: true
    },

    status: {
      type: Object,
      required: true
    }
  },

  components: {
    ciIcon: __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_ci_icon_vue___default.a
  }
});

/***/ }),

/***/ "U6NV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_component_vue__ = __webpack_require__("//z2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__action_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_action_component_vue__ = __webpack_require__("fu1Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_action_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dropdown_action_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__job_name_component_vue__ = __webpack_require__("ws8e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__job_name_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__job_name_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_mixins_tooltip__ = __webpack_require__("qHTm");






/**
 * Renders the badge for the pipeline graph and the job's dropdown.
 *
 * The following object should be provided as `job`:
 *
 * {
 *   "id": 4256,
 *   "name": "test",
 *   "status": {
 *     "icon": "icon_status_success",
 *     "text": "passed",
 *     "label": "passed",
 *     "group": "success",
 *     "details_path": "/root/ci-mock/builds/4256",
 *     "action": {
 *       "icon": "icon_action_retry",
 *       "title": "Retry",
 *       "path": "/root/ci-mock/builds/4256/retry",
 *       "method": "post"
 *     }
 *   }
 * }
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    job: {
      type: Object,
      required: true
    },

    cssClassJobName: {
      type: String,
      required: false,
      default: ''
    },

    isDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    actionComponent: __WEBPACK_IMPORTED_MODULE_0__action_component_vue___default.a,
    dropdownActionComponent: __WEBPACK_IMPORTED_MODULE_1__dropdown_action_component_vue___default.a,
    jobNameComponent: __WEBPACK_IMPORTED_MODULE_2__job_name_component_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_shared_mixins_tooltip__["a" /* default */]],

  computed: {
    tooltipText: function tooltipText() {
      return this.job.name + ' - ' + this.job.status.label;
    },


    /**
     * Verifies if the provided job has an action path
     *
     * @return {Boolean}
     */
    hasAction: function hasAction() {
      return this.job.status && this.job.status.action && this.job.status.action.path;
    }
  }
});

/***/ }),

/***/ "UPUc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_visibilityjs__ = __webpack_require__("a7Ve");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_visibilityjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_visibilityjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_poll__ = __webpack_require__("Dx73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_pipeline_service__ = __webpack_require__("WtSm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_pipeline_store__ = __webpack_require__("t0qB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stage_column_component_vue__ = __webpack_require__("3U/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stage_column_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__stage_column_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flash__ = __webpack_require__("nYQN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flash__);

/* global Flash */







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    stageColumnComponent: __WEBPACK_IMPORTED_MODULE_4__stage_column_component_vue___default.a
  },

  data: function data() {
    var DOMdata = document.getElementById('js-pipeline-graph-vue').dataset;
    var store = new __WEBPACK_IMPORTED_MODULE_3__stores_pipeline_store__["a" /* default */]();

    return {
      isLoading: false,
      endpoint: DOMdata.endpoint,
      store: store,
      state: store.state
    };
  },
  created: function created() {
    this.service = new __WEBPACK_IMPORTED_MODULE_2__services_pipeline_service__["a" /* default */](this.endpoint);

    var poll = new __WEBPACK_IMPORTED_MODULE_1__lib_utils_poll__["a" /* default */]({
      resource: this.service,
      method: 'getPipeline',
      successCallback: this.successCallback,
      errorCallback: this.errorCallback
    });

    if (!__WEBPACK_IMPORTED_MODULE_0_visibilityjs___default.a.hidden()) {
      this.isLoading = true;
      poll.makeRequest();
    }

    __WEBPACK_IMPORTED_MODULE_0_visibilityjs___default.a.change(function () {
      if (!__WEBPACK_IMPORTED_MODULE_0_visibilityjs___default.a.hidden()) {
        poll.restart();
      } else {
        poll.stop();
      }
    });
  },


  methods: {
    successCallback: function successCallback(response) {
      var data = response.json();

      this.isLoading = false;
      this.store.storeGraph(data.details.stages);
    },
    errorCallback: function errorCallback() {
      this.isLoading = false;
      return new Flash('An error occurred while fetching the pipeline.');
    },
    capitalizeStageName: function capitalizeStageName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    isFirstColumn: function isFirstColumn(index) {
      return index === 0;
    },
    stageConnectorClass: function stageConnectorClass(index, stage) {
      var className = void 0;

      // If it's the first stage column and only has one job
      if (index === 0 && stage.groups.length === 1) {
        className = 'no-margin';
      } else if (index > 0) {
        // If it is not the first column
        className = 'left-margin';
      }

      return className;
    }
  }
});

/***/ }),

/***/ "V7le":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><circle cx=\"7\" cy=\"7\" r=\"3.25\"/></g></svg>\n"

/***/ }),

/***/ "VVL9":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    ref: "tooltip",
    staticClass: "ci-action-icon-container",
    attrs: {
      "data-method": _vm.actionMethod,
      "title": _vm.tooltipText,
      "href": _vm.link,
      "data-toggle": "tooltip",
      "data-container": "body"
    }
  }, [_c('i', {
    staticClass: "ci-action-icon-wrapper",
    class: _vm.cssClass,
    attrs: {
      "aria-hidden": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.actionIconSvg)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ "WbY0":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("hPAi"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "WtSm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("7UJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_resource__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource___default.a);

var PipelineService = function () {
  function PipelineService(endpoint) {
    _classCallCheck(this, PipelineService);

    this.pipeline = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(endpoint);
  }

  _createClass(PipelineService, [{
    key: 'getPipeline',
    value: function getPipeline() {
      return this.pipeline.get();
    }
  }]);

  return PipelineService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelineService);

/***/ }),

/***/ "YRyE":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M7 3c2.2 0 4 1.8 4 4s-1.8 4-4 4c-1.3 0-2.5-.7-3.3-1.7L7 7V3\"/></g></svg>\n"

/***/ }),

/***/ "a7Ve":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("WbY0")


/***/ }),

/***/ "bI9i":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("js6r")(
  /* script */
  __webpack_require__("U6NV"),
  /* template */
  __webpack_require__("pIwE"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "bSTq":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.42857143,5.5 C9.42857143,5.02857143 9.74285714,4.71428571 10.2142857,4.71428571 L11.7857143,4.71428571 C12.2571429,4.71428571 12.5714286,5.02857143 12.5714286,5.5 L12.5714286,11.7857143 C12.5714286,12.2571429 12.2571429,12.5714286 11.7857143,12.5714286 L10.2142857,12.5714286 C9.74285714,12.5714286 9.42857143,12.2571429 9.42857143,11.7857143 L9.42857143,5.5 M9.42857143,14.9285714 C9.42857143,14.4571429 9.74285714,14.1428571 10.2142857,14.1428571 L11.7857143,14.1428571 C12.2571429,14.1428571 12.5714286,14.4571429 12.5714286,14.9285714 L12.5714286,16.5 C12.5714286,16.9714286 12.2571429,17.2857143 11.7857143,17.2857143 L10.2142857,17.2857143 C9.74285714,17.2857143 9.42857143,16.9714286 9.42857143,16.5 L9.42857143,14.9285714\" id=\"Shape\"></path></svg>\n"

/***/ }),

/***/ "cXhu":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.0846,12.1 L10.6623,13.5223 C10.2454306,13.9539168 10.2513924,14.6399933 10.6756996,15.0643004 C11.1000067,15.4886076 11.7860832,15.4945694 12.2177,15.0777 L15.1261,12.1693 C15.7708612,11.5230891 15.7708612,10.4769109 15.1261,9.8307 L12.2177,6.9223 C11.7860832,6.50543057 11.1000067,6.51139239 10.6756996,6.93569957 C10.2513924,7.36000675 10.2454306,8.04608322 10.6623,8.4777 L12.0846,9.9 L7.04,9.9 C6.43248678,9.9 5.94,10.3924868 5.94,11 C5.94,11.6075132 6.43248678,12.1 7.04,12.1 L12.0846,12.1 L12.0846,12.1 Z\" id=\"Shape\"></path></svg>\n"

/***/ }),

/***/ "fgF3":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M5.2 3.8l4.9 4.9c.2.2.2.5 0 .7l-.7.7c-.2.2-.5.2-.7 0L3.8 5.2c-.2-.2-.2-.5 0-.7l.7-.7c.2-.2.5-.2.7 0\"/></g></svg>\n"

/***/ }),

/***/ "fu1Y":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("js6r")(
  /* script */
  __webpack_require__("oww9"),
  /* template */
  __webpack_require__("L3NB"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "hPAi":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "hhN7":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M10.5 7.63V6.37l-.787-.13c-.044-.175-.132-.349-.263-.61l.481-.652-.918-.913-.657.478a2.346 2.346 0 0 0-.612-.26L7.656 3.5H6.388l-.132.783c-.219.043-.394.13-.612.26l-.657-.478-.918.913.437.652c-.131.218-.175.392-.262.61l-.744.086v1.261l.787.13c.044.218.132.392.263.61l-.438.651.92.913.655-.434c.175.086.394.173.613.26l.131.783h1.313l.131-.783c.219-.043.394-.13.613-.26l.656.478.918-.913-.48-.652c.13-.218.218-.435.262-.61l.656-.13zM7 8.283a1.285 1.285 0 0 1-1.313-1.305c0-.739.57-1.304 1.313-1.304.744 0 1.313.565 1.313 1.304 0 .74-.57 1.305-1.313 1.305z\"/></g></svg>\n"

/***/ }),

/***/ "ji5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_ci_action_icons__ = __webpack_require__("/hNe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_mixins_tooltip__ = __webpack_require__("qHTm");




/**
 * Renders either a cancel, retry or play icon pointing to the given path.
 * TODO: Remove UJS from here and use an async request instead.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    tooltipText: {
      type: String,
      required: true
    },

    link: {
      type: String,
      required: true
    },

    actionMethod: {
      type: String,
      required: true
    },

    actionIcon: {
      type: String,
      required: true
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__vue_shared_mixins_tooltip__["a" /* default */]],

  computed: {
    actionIconSvg: function actionIconSvg() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue_shared_ci_action_icons__["a" /* default */])(this.actionIcon);
    },
    cssClass: function cssClass() {
      return 'js-' + gl.text.dasherize(this.actionIcon);
    }
  }
});

/***/ }),

/***/ "js6r":
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "jyEk":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("js6r")(
  /* script */
  __webpack_require__("8KGO"),
  /* template */
  __webpack_require__("DWvw"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "lE6B":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M6.278 7.697L5.045 6.464a.296.296 0 0 0-.42-.002l-.613.614a.298.298 0 0 0 .002.42l1.91 1.909a.5.5 0 0 0 .703.005l.265-.265L9.997 6.04a.291.291 0 0 0-.009-.408l-.614-.614a.29.29 0 0 0-.408-.009L6.278 7.697z\"/></g></svg>\n"

/***/ }),

/***/ "oww9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_ci_action_icons__ = __webpack_require__("/hNe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_mixins_tooltip__ = __webpack_require__("qHTm");




/**
 * Renders either a cancel, retry or play icon pointing to the given path.
 * TODO: Remove UJS from here and use an async request instead.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    tooltipText: {
      type: String,
      required: true
    },

    link: {
      type: String,
      required: true
    },

    actionMethod: {
      type: String,
      required: true
    },

    actionIcon: {
      type: String,
      required: true
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__vue_shared_mixins_tooltip__["a" /* default */]],

  computed: {
    actionIconSvg: function actionIconSvg() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue_shared_ci_action_icons__["a" /* default */])(this.actionIcon);
    }
  }
});

/***/ }),

/***/ "pIwE":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.job.status.details_path) ? _c('a', {
    ref: "tooltip",
    class: _vm.cssClassJobName,
    attrs: {
      "href": _vm.job.status.details_path,
      "title": _vm.tooltipText,
      "data-toggle": "tooltip",
      "data-container": "body"
    }
  }, [_c('job-name-component', {
    attrs: {
      "name": _vm.job.name,
      "status": _vm.job.status
    }
  })], 1) : _c('div', {
    ref: "tooltip",
    class: _vm.cssClassJobName,
    attrs: {
      "title": _vm.tooltipText,
      "data-toggle": "tooltip",
      "data-container": "body"
    }
  }, [_c('job-name-component', {
    attrs: {
      "name": _vm.job.name,
      "status": _vm.job.status
    }
  })], 1), _vm._v(" "), (_vm.hasAction && !_vm.isDropdown) ? _c('action-component', {
    attrs: {
      "tooltip-text": _vm.job.status.action.title,
      "link": _vm.job.status.action.path,
      "action-icon": _vm.job.status.action.icon,
      "action-method": _vm.job.status.action.method
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasAction && _vm.isDropdown) ? _c('dropdown-action-component', {
    attrs: {
      "tooltip-text": _vm.job.status.action.title,
      "link": _vm.job.status.action.path,
      "action-icon": _vm.job.status.action.icon,
      "action-method": _vm.job.status.action.method
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "t0qB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PipelineStore = function () {
  function PipelineStore() {
    _classCallCheck(this, PipelineStore);

    this.state = {};

    this.state.graph = [];
  }

  _createClass(PipelineStore, [{
    key: "storeGraph",
    value: function storeGraph() {
      var graph = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.state.graph = graph;
    }
  }]);

  return PipelineStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelineStore);

/***/ }),

/***/ "tGpj":
/***/ (function(module, exports) {

module.exports = "<svg width=\"30px\" height=\"30px\" viewBox=\"0 0 30 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.1357204,10.2985704 L20.1357204,19.7271418 C20.1357204,19.8432138 20.0933101,19.9436592 20.0084882,20.0284811 C19.9236664,20.1133029 19.823221,20.1557132 19.707149,20.1557132 L10.2785775,20.1557132 C10.1625055,20.1557132 10.0620601,20.1133029 9.97723825,20.0284811 C9.89241639,19.9436592 9.8500061,19.8432138 9.8500061,19.7271418 L9.8500061,10.2985704 C9.8500061,10.1824984 9.89241639,10.0820529 9.97723825,9.99723107 C10.0620601,9.91240922 10.1625055,9.86999893 10.2785775,9.86999893 L19.707149,9.86999893 C19.823221,9.86999893 19.9236664,9.91240922 20.0084882,9.99723107 C20.0933101,10.0820529 20.1357204,10.1824984 20.1357204,10.2985704 Z\"></path></svg>\n"

/***/ }),

/***/ "ub10":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('ci-icon', {
    attrs: {
      "status": _vm.status
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ci-status-text"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "un/A":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5,11.9906832 L16.5,10.0093168 L15.2625,9.80434783 C15.19375,9.5310559 15.05625,9.25776398 14.85,8.84782609 L15.60625,7.82298137 L14.1625,6.38819876 L13.13125,7.13975155 C12.7875,6.93478261 12.44375,6.79813665 12.16875,6.72981366 L12.03125,5.5 L10.0375,5.5 L9.83125,6.72981366 C9.4875,6.79813665 9.2125,6.93478261 8.86875,7.13975155 L7.8375,6.38819876 L6.39375,7.82298137 L7.08125,8.84782609 C6.875,9.18944099 6.80625,9.46273292 6.66875,9.80434783 L5.5,9.94099379 L5.5,11.9223602 L6.7375,12.1273292 C6.80625,12.4689441 6.94375,12.742236 7.15,13.0838509 L6.4625,14.1086957 L7.90625,15.5434783 L8.9375,14.8602484 C9.2125,14.9968944 9.55625,15.1335404 9.9,15.2701863 L10.10625,16.5 L12.16875,16.5 L12.375,15.2701863 C12.71875,15.2018634 12.99375,15.0652174 13.3375,14.8602484 L14.36875,15.6118012 L15.8125,14.1770186 L15.05625,13.1521739 C15.2625,12.810559 15.4,12.4689441 15.46875,12.1956522 L16.5,11.9906832 L16.5,11.9906832 Z M11,13.015528 C9.83125,13.015528 8.9375,12.1273292 8.9375,10.9658385 C8.9375,9.80434783 9.83125,8.91614907 11,8.91614907 C12.16875,8.91614907 13.0625,9.80434783 13.0625,10.9658385 C13.0625,12.1273292 12.16875,13.015528 11,13.015528 L11,13.015528 Z\" id=\"Shape\" ></path></svg>\n"

/***/ }),

/***/ "vxKc":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "stage-column",
    class: _vm.stageConnectorClass
  }, [_c('div', {
    staticClass: "stage-name"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "builds-container"
  }, [_c('ul', _vm._l((_vm.jobs), function(job, index) {
    return _c('li', {
      key: job.id,
      staticClass: "build",
      class: _vm.buildConnnectorClass(index),
      attrs: {
        "id": _vm.jobId(job)
      }
    }, [_c('div', {
      staticClass: "curve"
    }), _vm._v(" "), (job.size === 1) ? _c('job-component', {
      attrs: {
        "job": job,
        "css-class-job-name": "build-content"
      }
    }) : _vm._e(), _vm._v(" "), (job.size > 1) ? _c('dropdown-job-component', {
      attrs: {
        "job": job
      }
    }) : _vm._e()], 1)
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ "ws8e":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("js6r")(
  /* script */
  __webpack_require__("So2G"),
  /* template */
  __webpack_require__("ub10"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "x8RY":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M6 3.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-4m0 6c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1\"/></g></svg>\n"

/***/ }),

/***/ "yFnw":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11,4.71428571 C14.4571429,4.71428571 17.2857143,7.54285714 17.2857143,11 C17.2857143,14.4571429 14.4571429,17.2857143 11,17.2857143 C8.95714286,17.2857143 7.07142857,16.1857143 5.81428571,14.6142857 L11,11 L11,4.71428571\" id=\"Shape\"></path></svg>\n"

/***/ }),

/***/ "yRC4":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.38571429,8.32857143 C7.38571429,8.01428571 7.54285714,7.85714286 7.85714286,7.85714286 L9.27142857,7.85714286 C9.58571429,7.85714286 9.74285714,8.01428571 9.74285714,8.32857143 L9.74285714,13.6714286 C9.74285714,13.9857143 9.58571429,14.1428571 9.27142857,14.1428571 L7.85714286,14.1428571 C7.54285714,14.1428571 7.38571429,13.9857143 7.38571429,13.6714286 L7.38571429,8.32857143 M12.1,8.32857143 C12.1,8.01428571 12.2571429,7.85714286 12.5714286,7.85714286 L13.9857143,7.85714286 C14.3,7.85714286 14.4571429,8.01428571 14.4571429,8.32857143 L14.4571429,13.6714286 C14.4571429,13.9857143 14.3,14.1428571 13.9857143,14.1428571 L12.5714286,14.1428571 C12.2571429,14.1428571 12.1,13.9857143 12.1,13.6714286 L12.1,8.32857143\" id=\"Shape\"></path></svg>\n"

/***/ })

},["BX53"]);


// WEBPACK FOOTER //
// pipelines_graph.12b12baff5c571f14d45.bundle.js